import React, { useState, useEffect } from 'react'

export default function SearchInput() {
  const [keyboardShortcut, setKeyboardShortcut] = useState(() => {
    const stored = localStorage.getItem('commandPaletteShortcut')
    if (!stored) {
      localStorage.setItem('commandPaletteShortcut', 'cmd-k')
      return 'cmd-k'
    }
    return stored
  })

  useEffect(() => {
    const handleShortcutChange = () => {
      const stored = localStorage.getItem('commandPaletteShortcut')
      if (stored) {
        setKeyboardShortcut(stored)
      }
    }

    window.addEventListener('commandPaletteShortcutChange', handleShortcutChange)
    window.addEventListener('storage', handleShortcutChange)

    return () => {
      window.removeEventListener('commandPaletteShortcutChange', handleShortcutChange)
      window.removeEventListener('storage', handleShortcutChange)
    }
  }, [])

  const getShortcutDisplay = () => {
    if (keyboardShortcut === 'cmd-k') {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return (
        <>
          <kbd className="kbd kbd-sm">{isMac ? '⌘' : 'Ctrl'}</kbd>
          +
          <kbd className="kbd kbd-sm">K</kbd>
        </>
      )
    }
    return <kbd className="kbd kbd-sm">/</kbd>
  }

  const handleClick = () => {
    let event
    if (keyboardShortcut === 'cmd-k') {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      event = new KeyboardEvent('keydown', {
        key: 'k',
        metaKey: isMac,
        ctrlKey: !isMac,
        bubbles: true
      })
    } else {
      event = new KeyboardEvent('keydown', {
        key: '/',
        bubbles: true
      })
    }
    document.dispatchEvent(event)
  }

  return (
    <div className="flex items-center gap-2 w-full">
      <a href="/" className="flex-shrink-0">
        <img src="/icon.svg" alt="Logo" className="w-8 h-8 hover:opacity-70 transition-opacity" />
      </a>
      <button
        onClick={handleClick}
        className="flex items-center gap-2 input input-bordered input-md flex-1 text-left cursor-pointer"
      >
        <span className="opacity-50 text-sm">Search gists...</span>
        <span className="ml-auto hidden lg:flex gap-1 items-center">
          {getShortcutDisplay()}
        </span>
      </button>
    </div>
  )
}
